var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));

// src/components/ErrorBoundary/ErrorBoundary.tsx
import React2 from "react";

// src/components/ReportDialog/ReportDialog.tsx
import React, { useRef, useState } from "react";
var ReportDialog = ({
  labelClose = "Close",
  labelComments = "What happened?",
  labelEmail = "Email",
  labelName = "Name",
  labelSubmit = "Submit",
  subtitle2 = "If you\u2019d like to help, tell us what happened below.",
  subtitle = "Our team has been notified.",
  successMessage = "Your feedback has been sent. Thank you!",
  successSubtitle = "Thank you for sending us feedback. If you have any other concerns/questions, reach out to this application's support email.",
  title = "It looks like we\u2019re having issues.",
  placeholderComments = "I typed in a name then clicked the button",
  user,
  onCloseHandler,
  onSubmitHandler,
  hideHighlightBranding = false
}) => {
  const [name, setName] = useState((user == null ? void 0 : user.name) || "");
  const [email, setEmail] = useState((user == null ? void 0 : user.email) || "");
  const [verbatim, setVerbatim] = useState("");
  const [sendingReport, setSendingReport] = useState(false);
  const [sentReport, setSentReport] = useState(false);
  const reportDialogOpenTime = useRef((/* @__PURE__ */ new Date()).toISOString());
  const handleSubmit = (event) => {
    var _a;
    event.preventDefault();
    setSendingReport(true);
    if ((_a = window == null ? void 0 : window.H) == null ? void 0 : _a.addSessionFeedback) {
      window.H.addSessionFeedback({
        verbatim,
        userName: name,
        userEmail: email,
        timestampOverride: reportDialogOpenTime.current
      });
    } else {
      console.warn(
        "Highlight is not initialized. Make sure highlight.run is installed and running."
      );
    }
    new Promise((r) => window.setTimeout(r, 300)).then(() => {
      setSendingReport(false);
      setSentReport(true);
      if (onSubmitHandler) {
        onSubmitHandler();
      }
    });
  };
  return /* @__PURE__ */ React.createElement("main", { className: `container` }, /* @__PURE__ */ React.createElement("div", { className: `card` }, /* @__PURE__ */ React.createElement(
    "div",
    {
      className: `cardContents ${sentReport && "cardContentsVisible"}`
    },
    /* @__PURE__ */ React.createElement("h1", { className: `title` }, successMessage),
    /* @__PURE__ */ React.createElement("h4", { className: `subtitle` }, successSubtitle),
    /* @__PURE__ */ React.createElement(
      "button",
      {
        className: `button confirmationButton`,
        onClick: onCloseHandler
      },
      "Close"
    )
  ), /* @__PURE__ */ React.createElement(
    "div",
    {
      className: `cardContents ${!sentReport && "cardContentsVisible"}`
    },
    /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("h1", { className: `title` }, title), /* @__PURE__ */ React.createElement("h2", { className: `subtitle` }, subtitle, " ", subtitle2)),
    /* @__PURE__ */ React.createElement("form", { className: `form`, onSubmit: handleSubmit }, /* @__PURE__ */ React.createElement("label", null, labelName, /* @__PURE__ */ React.createElement(
      "input",
      {
        type: "text",
        value: name,
        name: "name",
        autoFocus: true,
        onChange: (e) => {
          setName(e.target.value);
        }
      }
    )), /* @__PURE__ */ React.createElement("label", null, labelEmail, /* @__PURE__ */ React.createElement(
      "input",
      {
        type: "email",
        value: email,
        name: "email",
        onChange: (e) => {
          setEmail(e.target.value);
        }
      }
    )), /* @__PURE__ */ React.createElement("label", null, labelComments, /* @__PURE__ */ React.createElement(
      "textarea",
      {
        value: verbatim,
        placeholder: placeholderComments,
        name: "verbatim",
        rows: 3,
        onChange: (e) => {
          setVerbatim(e.target.value);
        }
      }
    )), /* @__PURE__ */ React.createElement("div", { className: `formFooter` }, /* @__PURE__ */ React.createElement("div", { className: `formActionsContainer` }, /* @__PURE__ */ React.createElement(
      "button",
      {
        type: "submit",
        className: sendingReport ? `button loadingButton` : "button"
      },
      labelSubmit
    ), /* @__PURE__ */ React.createElement(
      "button",
      {
        className: `button closeButton`,
        onClick: onCloseHandler,
        type: "button"
      },
      labelClose
    )), !hideHighlightBranding && /* @__PURE__ */ React.createElement("div", { className: `ad` }, /* @__PURE__ */ React.createElement("p", { className: `logoContainer` }, "Crash reports powered by:", /* @__PURE__ */ React.createElement(
      "a",
      {
        href: "https://highlight.run",
        target: "_blank"
      },
      /* @__PURE__ */ React.createElement(
        "img",
        {
          src: "https://app.highlight.run/logo-24x130.png",
          alt: "Highlight",
          height: "25",
          className: `logo`
        }
      )
    )))))
  )));
};
var ReportDialog_default = ReportDialog;

// src/components/ErrorBoundary/ErrorBoundary.tsx
var INITIAL_STATE = {
  componentStack: null,
  error: null,
  showingDialog: false
};
var ErrorBoundary = class extends React2.Component {
  constructor() {
    super(...arguments);
    this.state = INITIAL_STATE;
    this.resetErrorBoundary = () => {
      const { onReset } = this.props;
      const { error, componentStack } = this.state;
      if (onReset) {
        onReset(error, componentStack);
      }
      this.setState(INITIAL_STATE);
    };
    this.hideDialog = () => {
      this.setState(__spreadProps(__spreadValues({}, this.state), { showingDialog: false }));
      if (this.props.onAfterReportDialogCancelHandler) {
        this.props.onAfterReportDialogCancelHandler();
      }
    };
    this.onReportDialogSubmitHandler = () => {
      if (this.props.onAfterReportDialogSubmitHandler) {
        this.props.onAfterReportDialogSubmitHandler();
      }
    };
  }
  componentDidCatch(error, errorInfo) {
    const { beforeCapture, onError, showDialog } = this.props;
    if (beforeCapture) {
      beforeCapture(error, errorInfo.componentStack);
    }
    captureReactErrorBoundaryError(error, errorInfo.componentStack);
    if (onError) {
      onError(error, errorInfo.componentStack);
    }
    if (showDialog) {
      this.setState(__spreadProps(__spreadValues({}, this.state), { showingDialog: true }));
    }
    this.setState({ error, componentStack: errorInfo.componentStack });
  }
  componentDidMount() {
    const { onMount } = this.props;
    if (onMount) {
      onMount();
    }
  }
  componentWillUnmount() {
    const { error, componentStack } = this.state;
    const { onUnmount } = this.props;
    if (onUnmount) {
      onUnmount(error, componentStack);
    }
  }
  render() {
    const { fallback, children, customDialog } = this.props;
    const { error, componentStack, showingDialog } = this.state;
    if (error) {
      let element = void 0;
      if (typeof fallback === "function") {
        element = fallback({
          error,
          componentStack,
          resetError: this.resetErrorBoundary
        });
      } else {
        element = fallback;
      }
      if (React2.isValidElement(element)) {
        return /* @__PURE__ */ React2.createElement(React2.Fragment, null, showingDialog && /* @__PURE__ */ React2.createElement(
          ReportDialog_default,
          __spreadProps(__spreadValues({}, this.props.dialogOptions), {
            onCloseHandler: this.hideDialog,
            onSubmitHandler: this.onReportDialogSubmitHandler
          })
        ), element);
      }
      if (fallback) {
        console.warn("fallback did not produce a valid ReactElement");
      }
      if (showingDialog && customDialog) {
        return customDialog;
      }
      return showingDialog && /* @__PURE__ */ React2.createElement(
        ReportDialog_default,
        __spreadProps(__spreadValues({}, this.props.dialogOptions), {
          onCloseHandler: this.hideDialog,
          onSubmitHandler: this.onReportDialogSubmitHandler
        })
      );
    }
    if (typeof children === "function") {
      return children();
    }
    return children;
  }
};
function captureReactErrorBoundaryError(error, componentStack) {
  const errorBoundaryError = new Error(` ${error.message}`);
  errorBoundaryError.name = `React ErrorBoundary ${error.name}`;
  errorBoundaryError.stack = error.stack;
  const componentName = getComponentNameFromStack(componentStack);
  if (!window.H) {
    console.warn("You need to install highlight.run as a npm dependency.");
  } else {
    window.H.consumeError(
      errorBoundaryError,
      `${componentName ? `ErrorBoundary ${componentName}` : "HighlightErrorBoundary"}`
    );
  }
}
function getComponentNameFromStack(componentStack) {
  const stack = componentStack.split("\n");
  if (stack.length < 1) {
    return void 0;
  }
  const leafComponentLine = stack[1].trim();
  const tokens = leafComponentLine.split(" ");
  if (tokens.length !== 4) {
    return void 0;
  }
  return `<${tokens[1]}>`;
}

// src/components/SampleBuggyButton/SampleBuggyButton.tsx
import React3 from "react";
var SampleBuggyButton = ({
  children
}) => {
  const [isError, setError] = React3.useState(false);
  if (isError) {
    throw new Error("something bad happened - this is a sample test error");
  }
  return /* @__PURE__ */ React3.createElement(
    "button",
    {
      type: "button",
      className: "buggyButton",
      onClick: () => setError(true)
    },
    children != null ? children : "Throw an Error"
  );
};
export {
  ErrorBoundary,
  SampleBuggyButton
};
